import { render, staticRenderFns } from "./ListCafeteriaPage.vue?vue&type=template&id=76286e52"
import script from "./ListCafeteriaPage.vue?vue&type=script&lang=js"
export * from "./ListCafeteriaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports